import { ThemeProvider, CssBaseline } from '@mui/material'
import { BrowserRouter } from 'react-router-dom'
import theme from './theme/theme'
import AppRoutes from './routes/AppRoutes'
import SmoothScrollProvider from './components/common/SmoothScrollProvider'

function App() {
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <BrowserRouter>
        <SmoothScrollProvider>
          <AppRoutes />
        </SmoothScrollProvider>
      </BrowserRouter>
    </ThemeProvider>
  )
}

export default App
